import { createRouter, createWebHistory } from "vue-router";
import VxHome from "@/views/VxHome.vue";
import VxBlog from "@/views/VxBlog.vue";
import VxPost from "@/views/VxPost.vue";
import VxServices from "@/views/VxServices.vue";
import VxPortfolio from "@/views/VxPortfolio.vue";
import VxPoliticaPrivacidad from "@/views/VxPoliticaPrivacidad.vue";
import VxEditPost from "@/views/VxEditPost.vue";

const routes = [
  { path: "/", component: VxHome },
  { path: "/blog", component: VxBlog },
  { path: "/post/:id", name: 'VxPost', component: VxPost },
  { path: "/servicios", component: VxServices },
  { path: "/portfolio", component: VxPortfolio },
  { path: "/politica-privacidad", component: VxPoliticaPrivacidad },
  { path: "/edit-post", component: VxEditPost},
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
